import React, {useEffect, useState} from 'react';
import {styles} from "./OpeningCountDownViewStyle";
import {TranslationView} from "@levelapp/softfabric-ui";
import {Text, View} from "react-native";
import {useWindowSizeContext} from "../../../../../../../Common/contexts/WindowSizeContext";

interface OpeningCountDownViewProps {
    openingDate: Date;
    setIsProjectOpened: (isProjectOpened: boolean) => void;
}

export default function OpeningCountDownView({openingDate, setIsProjectOpened}: OpeningCountDownViewProps) {

    const {isMobile} = useWindowSizeContext();
    const [days, setDays] = useState<string>("0");
    const [hours, setHours] = useState<string>("0");
    const [minutes, setMinutes] = useState<string>("0");
    const [seconds, setSeconds] = useState<string>("0");

    const fontSizeFactor = isMobile ? 0.8 : 1;

    const titleFontSize = 22 * fontSizeFactor;
    const subtitleFontSize = 16 * fontSizeFactor;
    const countDownTimeValueTextFontSize = 32 * fontSizeFactor;
    const countDownTimeTextFontSize = 14 * fontSizeFactor;

    const countDownDate = openingDate.getTime();

    function calculateCountDownDateTime(): number {
        // Get today's date and time
        const now = new Date().getTime();

        // Find the distance between now and the count down date
        const distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        let daysTmp: number | string = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hoursTmp: number | string = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutesTmp: number | string = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let secondsTmp: number | string = Math.floor((distance % (1000 * 60)) / 1000);

        if (daysTmp < 10)
            daysTmp = "0" + daysTmp;

        if (hoursTmp < 10)
            hoursTmp = "0" + hoursTmp;

        if (minutesTmp < 10)
            minutesTmp = "0" + minutesTmp;

        if (secondsTmp < 10)
            secondsTmp = "0" + secondsTmp;

        setDays(daysTmp.toString());
        setHours(hoursTmp.toString());
        setMinutes(minutesTmp.toString());
        setSeconds(secondsTmp.toString());

        return distance;
    }

    useEffect(() => {
        calculateCountDownDateTime();
        const clock = setInterval(() => {
            const distance: number = calculateCountDownDateTime();

            if (distance < 0) {
                setIsProjectOpened(true);
                clearInterval(clock);
            }
        }, 1000);

        return () => clearInterval(clock);
    }, []);

    return (
        <>
            <TranslationView style={[styles.title, styles.textWhite, {fontSize: titleFontSize}]}>details.openingdate.countdown.text</TranslationView>
            <View style={[styles.openingDateTextContainer]}>
                <Text style={[styles.subTitle, styles.textWhite, {fontSize: subtitleFontSize}]}>{openingDate.toLocaleDateString()} </Text>
                <TranslationView style={[styles.subTitle, styles.textWhite, {fontSize: subtitleFontSize}]}>details.openingdate.countdown.text.at</TranslationView>
                <Text style={[styles.subTitle, styles.textWhite, {fontSize: subtitleFontSize}]}> {openingDate.toLocaleTimeString()}</Text>
            </View>
            <View style={[styles.countDownTimeRowContainer]}>
                <View style={[styles.countDownTimeColumnContainer]}>
                    <Text style={[styles.countDownTimeValueText, styles.textWhite, {fontSize: countDownTimeValueTextFontSize}]}>{days}</Text>
                    <TranslationView style={[styles.countDownTimeText, styles.textWhite, {fontSize: countDownTimeTextFontSize}]}>details.openingdate.countdown.days</TranslationView>
                </View>
                <Text style={[styles.countDownTimeValueText, styles.textWhite, {fontSize: countDownTimeValueTextFontSize}]}>:</Text>
                <View style={[styles.countDownTimeColumnContainer]}>
                    <Text style={[styles.countDownTimeValueText, styles.textWhite, {fontSize: countDownTimeValueTextFontSize}]}>{hours}</Text>
                    <TranslationView style={[styles.countDownTimeText, styles.textWhite, {fontSize: countDownTimeTextFontSize}]}>details.openingdate.countdown.hours</TranslationView>
                </View>

                <Text style={[styles.countDownTimeValueText, styles.textWhite, {fontSize: countDownTimeValueTextFontSize}]}>:</Text>
                <View style={[styles.countDownTimeColumnContainer]}>
                    <Text style={[styles.countDownTimeValueText, styles.textWhite, {fontSize: countDownTimeValueTextFontSize}]}>{minutes}</Text>
                    <TranslationView style={[styles.countDownTimeText, styles.textWhite, {fontSize: countDownTimeTextFontSize}]}>details.openingdate.countdown.minutes</TranslationView>
                </View>

                <Text style={[styles.countDownTimeValueText, styles.textWhite, {fontSize: countDownTimeValueTextFontSize}]}>:</Text>

                <View style={[styles.countDownTimeColumnContainer]}>
                    <Text style={[styles.countDownTimeValueText, styles.textWhite, {fontSize: countDownTimeValueTextFontSize}]}>{seconds}</Text>
                    <TranslationView style={[styles.countDownTimeText, styles.textWhite, {fontSize: countDownTimeTextFontSize}]}>details.openingdate.countdown.seconds</TranslationView>
                </View>

            </View>

        </>
    );
}